import React from 'react';
import { ExpandMoreIcon } from '../../Icon';
function DropdownButtonIcon(_a) {
    var icon = _a.icon;
    return icon ? icon : React.createElement(ExpandMoreIcon, null);
}
export default DropdownButtonIcon;
